import { Component } from '@angular/core';

@Component({
  selector: 'app-exsep',
  templateUrl: './exsep.component.html',
  styleUrl: './exsep.component.scss'
})
export class ExsepComponent {

}
